<!-- 打印功能页 -->
<template>
  <div class="page-content">
    <c-header pageName="打印"></c-header>
    <div class="nav-tool">
      <section :class="selectStatus===0?'activity':''" @click="statusChange(0)">库位打印</section>
      <section :class="selectStatus===1?'activity':''" @click="statusChange(1)">固定资产打印</section>
    </div>
    <div class="search-form flex-wrap">
      <section>
        <label>仓库</label>
        <div class="content-item flex">
          <section
            class="flex ml-10"
            v-if="ownWarehouseList.length>0"
            @click="handleSelectWarehouse"
          >{{ selectWarehouse.warehouseName ? selectWarehouse.warehouseName : "请选择仓库" }}
          </section>
          <section class="flex" v-else>{{ selectWarehouse.warehouseName }}</section>
          <van-icon name="arrow-down" class="mr-10"/>
        </div>
      </section>
      <section v-show="selectStatus===0">
        <label>初始值</label>
        <label class="w-full">
          <van-field class="w-full" v-model="searchInfo.startCode"/>
        </label>
      </section>
      <section v-show="selectStatus===0">
        <label>结束值</label>
        <label class="w-full">
          <van-field class="w-full" v-model="searchInfo.endCode"/>
        </label>
      </section>
      <section v-show="selectStatus===1">
        <label>编码</label>
        <label class="w-full">
          <van-field class="w-full" v-model="searchInfo.assetsCode"/>
        </label>
      </section>
      <section class="print-sub">
        <span @click="onPrintSub">打印</span>
      </section>
    </div>
    <van-picker
      show-toolbar
      v-show="showWarehousePicker"
      :columns="warehousePicker"
      @confirm="handleWarehouseConfirm"
      @cancel="showWarehousePicker = false"
    />
  </div>
</template>

<script>
import Header from "../components/headerNav.vue";
import StorageUtil from "../util/storage.js";

export default {
  data() {
    return {
      member: {},
      selectStatus: 0, // 0--库位打印， 1--固定资产打印
      showWarehousePicker: false,
      ownWarehouseList: [], // 用户绑定的仓库
      selectWarehouse: {}, // 选中的仓库
      warehousePicker: [],
      searchInfo: {
        warehouseId: "",
        endCode: "",
        startCode: "",
        assetsCode: "" // 编码
      }
    };
  },
  components: {
    "c-header": Header
  },
  mounted() {
    this.member = StorageUtil.getLocalStorage("member");
    this.handleWarehouseList();
  },
  methods: {
    // 导航切换
    statusChange(value) {
      this.selectStatus = value;
    },
    // 查询用户绑定的仓库
    handleWarehouseList() {
      this.$post(this.URL.getWarehouseList, {
        ids: this.member.ownWarehouseIds
      }).then(res => {
        if (res.success) {
          this.ownWarehouseList = res.data;
          this.warehousePicker = this.ownWarehouseList.map(item => {
            return item.warehouseName;
          });
          if (this.ownWarehouseList.length === 1) {
            this.selectWarehouse = this.ownWarehouseList[0];
          }
        } else {
          this.$toast.fail(res.message);
        }
      });
    },
    // 点击弹出选中框
    handleSelectWarehouse() {
      this.showWarehousePicker = true;
    },
    // 仓库选择
    handleWarehouseConfirm(value, index) {
      this.selectWarehouse = this.ownWarehouseList[index];
      this.showWarehousePicker = false;
    },
    // 打印提交
    onPrintSub() {
      let param = {};
      let requestUrl = "";
      if (this.selectStatus === 0) {
        requestUrl = this.URL.findSlList;
        param.warehouseId = this.selectWarehouse.id;
        param.startCode = this.searchInfo.startCode;
        param.endCode = this.searchInfo.endCode;
      } else {
        requestUrl = this.URL.printAssetsInfo;
        param.id = this.selectWarehouse.id;
        param.strValue = this.searchInfo.assetsCode;
      }
      this.$post(requestUrl, param).then(res => {
        if (res.success && res.data) {
          if (this.selectStatus === 0) {
            res.data.forEach(item => {
              let data = "2," + item.slCode
              window.printSupport.share(data)
            })
          } else {
            let data = "2," + res.data.assetsCode
            window.printSupport.share(data)
          }
        } else {
          this.$toast.fail(res.message);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.nav-tool {
  display: flex;
  width: 100%;
  height: 3rem;
  background-color: #dc6350;
  padding: 0 3rem;
  align-items: center;
  justify-content: center;

  section {
    display: inline-flex;
    width: 7rem;
    justify-content: center;
    border: 1px solid #fff;
    height: 1.8rem;
    align-items: center;
    font-size: 0.9rem;
    color: white;
  }

  .activity {
    background-color: white;
    color: #dc6350;
  }

  section:first-child {
    border-top-left-radius: 0.2rem;
    border-bottom-left-radius: 0.2rem;
  }

  section:last-child {
    border-top-right-radius: 0.2rem;
    border-bottom-right-radius: 0.2rem;
  }
}

.search-form {
  font-size: 0.85rem;
  color: #444;
  padding: 1rem;

  section {
    display: flex;
    width: 100%;
    height: 3rem;
    align-items: center;

    label:first-child {
      display: inline-flex;
      width: 5rem;
    }
  }

  .print-sub {
    margin-top: 1.5rem;
    align-items: center;
    color: #fff;

    span {
      display: flex;
      background-color: #dc6350;
      width: 100%;
      height: 2.2rem;
      align-items: center;
      border-radius: 0.3rem;
      justify-content: center;
    }
  }

  .van-cell {
    padding: 0;
    border: 1px solid #f0f0f0;
    border-radius: 0.2rem;
    width: 13rem;
    padding-left: 0.5rem;
    line-height: 2rem;
  }
}

.w-select {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

</style>



// WEBPACK FOOTER //
// src/pages/Print.vue